'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: '문의',
    classes: 'btn-ghost hidden-xs gold',
    link: '/contact'
  }, {
    text: 'LOGIN',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: '제품'
    },
    list: [{
      text: 'Expense',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/expense-management'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }, {
        text: 'Travel & Expense',
        src: '/travel-expense'
      }, {
        text: 'Audit Service',
        src: '/travel-expense-audit-service'
      }]
    }, {
      text: 'Invoice',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Invoice',
        src: '/invoice-management'
      }]
    }, {
      text: 'Data insights',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Analytics',
        src: '/analytics'
      }, {
        text: 'Intelligence',
        src: '/business-intelligence'
      }]
    }, {
      text: 'Integration',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'SAP Integration',
        src: '/sap-integration'
      }, {
        text: 'Platform',
        src: '/open-platform-apps'
      }]
    }, {
      text: 'Support Offering',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Service Administration',
        src: '/service-administration'
      }, {
        text: 'Preferred Care',
        src: '/preferred-care'
      }]
    }]
  }, {
    title: {
      text: '솔루션'
    },
    list: [{
      text: 'By business need',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Duty of Care',
        src: '/duty-of-care'
      }, {
        text: 'Global expansion',
        src: '/global-travel-expense-management'
      }, {
        text: 'Intelligent Spend Management',
        src: '/intelligent-spend-management'
      }, {
        text: 'Strategic Spend Management',
        src: '/strategic-spend-management'
      }, {
        text: 'Visibility and control',
        src: '/visibility-and-compliance'
      }, {
        text: 'Fraud and compliance',
        src: '/compliance-fraud'
      }, {
        text: 'Productivity',
        src: '/productivity'
      }]
    }, {
      text: 'By role',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: '재무',
        src: '/financial-manager-solutions'
      }, {
        text: 'IT',
        src: '/it-leader'
      }]
    }, {
      text: 'By industry',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Life Sciences',
        src: '/life-sciences'
      }, {
        text: 'Financial Service',
        src: '/financial-services-solution'
      }, {
        text: 'Manufacturing',
        src: '/manufacturing'
      }, {
        text: 'Technology Companies',
        src: '/technology'
      }]
    }]
  }, {
    title: {
      text: 'SAP Concur 소개'
    },
    list: [{
      text: 'About SAP Concur',
      src: '/about-concur'
    }, {
      text: 'WHY SAP Concur',
      src: '/why-concur'
    }, {
      text: '위치',
      src: '/contact/offices'
    }, {
      text: '채용 안내',
      src: ''
    }, {
      text: '고객지원',
      src: '/support'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Resource Center',
      src: '/resource-center'
    }, {
      text: '이벤트',
      src: '/events'
    }, {
      text: 'Concur Expense 데모 보기',
      src: '/self-guided-demo-expense-ko-kr#/',
      classes: 'call-out'
    }, {
      text: 'Concur Invoice 데모 보기',
      src: '/self-guided-demo-invoice-ko-kr#/',
      classes: 'call-out'
    }]
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};